module.exports = __webpack_public_path__ + "img/library_music.cc551b6d.svg";